export function onEnter(action: () => void | Promise<void>) {
  return (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      return action();
    }
  };
}
